import { MutationTree } from "vuex"
import { WidgetState } from "@/apps/StudentExchangeInformationColumnWidget/models/store-viewmodel"
import { ILabels } from "@/apps/StudentExchangeInformationColumnWidget/models/config-viewmodel"

export default <MutationTree<WidgetState>>{
    labels(state, labels: ILabels) {
        state.labels = labels
    },
    isModalOpen(state, isModalOpen: boolean) {
        state.isModalOpen = isModalOpen
    },
    offset(state, offset: number) {
        state.offset = offset
    }
}
